<ng-container *transloco="let t">
    <mat-card class="altair-card vulnerabilities-card bg-white border-radius border-none d-block"
        [class.component-dark-theme]="themeService.isDark()">
        <mat-card-content>
            <h5 class="mt-0 font-16">{{ t("vulnerabilities-discovered") }}&nbsp;<i class="ri-information-2-fill"
                    matTooltip="{{ t('total-vulnerabilities-discovered') }}"></i>
            </h5>
            <h2 class="text-danger my-3 text-center">
                <span>{{ (countUp == 0 ? countUp : count) | number }}</span>
            </h2>
            @if (countUp > 0) {
            <p class="text-muted mb-0">
                <span class="w-title text-danger">{{scan.critical_vulnerability_count}} Critical, {{scan.high_vulnerability_count}} High, {{scan.medium_vulnerability_count}}
                    Medium</span>
                <br>
                <span class="w-title text-primary">{{scan.low_vulnerability_count}} Low, {{scan.info_vulnerability_count}} Info, and {{scan.unknown_vulnerability_count}} Unknown
                    Vulnerabilities</span>
            </p>
            }
            @else {
            <p class="text-muted mb-0 small">{{ t("no-vulnerabilities-found") }}</p>
            <br>
            }
        </mat-card-content>
    </mat-card>
</ng-container>
